import './AboutSection.css';

function AboutSection() {
    return (
        
    <div>
        <h1 className="left clean-header display-header">Hi, I'm Noah Carlson</h1>

        {/* Quick Stats */}
        <div className="quick-stats">
            <div className="stat-item">
                <span className="stat-number">3.9</span>
                <span className="stat-label">GPA</span>
            </div>
            <div className="stat-item">
                <span className="stat-number">M.S.</span>
                <span className="stat-label">Computer Science</span>
            </div>
            <div className="stat-item">
                <span className="stat-number">D1</span>
                <span className="stat-label">Athlete</span>
            </div>
            <div className="stat-item">
                <span className="stat-number">8th</span>
                <span className="stat-label">Fastest in Utah History</span>
            </div>
        </div>
        {/* Contact Section - Styled Buttons */}
        <div className="contact-buttons">
            <a href="mailto:Noahrk14@gmail.com" className="contact-btn">
                <span className="contact-icon">✉</span>
                Noahrk14@gmail.com
            </a>
            <a href="https://www.linkedin.com/in/noahcarlson14" target="_blank" rel="noopener noreferrer" className="contact-btn">
                <span className="contact-icon">in</span>
                LinkedIn
            </a>
            <a href="https://github.com/Smirqy" target="_blank" rel="noopener noreferrer" className="contact-btn">
                <span className="contact-icon">⌘</span>
                GitHub
            </a>
        </div>
        <p> 
        I am a graduated Master's of Computer Science student at the University of Utah and am currently looking for career opportunities. 
        </p>

        

        

        <p>
        Over my time at the University of Utah I have been able to work on a variety of projects that allowed me to find my passion of creation and creative problem solving. 
        I have worked on projects ranging from web development to machine learning and have found that the act of working towards a longterm goal and seeing it through to completion is what drives me. 
        </p>
        <p>
        Along with the software development problems I have also constantly practiced setting goals and working tirelessly to achieve them.
        I was a competitive swimmer for over a decade and my long-term goal had always been to be a member of a fast Division 1 Swim team.
        After 6 years of training and competing I earned the opportunity to try-out to walk-on to the NCAA Men's Utah Swim and Dive team. 
        Once I made the team, I worked to prove that I belonged on the team and eventually in one
        of my events I went the 8th fastest time in the history of Utah Swim and Dive.
        </p>
        <p>
        That is just a short testiment to my work ethic and what I can achieve including this website!
        So, thank you for stopping by and I hope you enjoy!
        </p>

        {/* Skills Section - Compact */}
        <div className="skills-section">
            <div className="skills-row">
                <span className="skill-label">Languages:</span>
                <span className="skill-text">Python, JavaScript, Java, C++, C#, SQL, HTML, CSS</span>
            </div>
            <div className="skills-row">
                <span className="skill-label">Frameworks:</span>
                <span className="skill-text">React, Node.js, Three.js, Express, .NET, PyTorch, scikit-learn</span>
            </div>
            <div className="skills-row">
                <span className="skill-label">Tools:</span>
                <span className="skill-text">Git, Docker, AWS, MongoDB, PostgreSQL, Linux</span>
            </div>
        </div>
     </div>
    );
}

export default AboutSection;